var _a;
import { article, lodging, news, partnerActivity, place, poi, thorntreeForum, thorntreeTopic, video, } from "@lonelyplanet/open-planet-node/dist/openPlanetTypes";
export var opTypeMapping = (_a = {},
    _a[article] = "Article",
    _a[lodging] = "Hotel",
    _a[news] = "News",
    _a[partnerActivity] = "Activity",
    _a[place] = "Destination",
    _a[poi] = "Thing to do",
    _a[thorntreeForum] = "Thorntree forum",
    _a[thorntreeTopic] = "Thorntree topic",
    _a[video] = "Video",
    _a);



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/utils/opTypeMapping.ts
// module id = 97Rg
// module chunks = 2